/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
      
  const query = graphql`
  query ChargesFetchQuery($startDate: Datetime, $endDate: Datetime, $appName: String, $accountId: UUID, $pAccountId: UUID, $pOrder: Int, $first: Int, $offset: Int) {
    getchargesexternalsandpaymentswithsummary(startTs: $startDate, endTs: $endDate, appName: $appName, accountId: $accountId, pAccountId: $pAccountId, paymentOrder: $pOrder, first: $first, offset: $offset) {
      totalCount
      nodes {
        toCustSum
        toMeSum
        bcChargeSum
        markupSum
        feeSum
        ppcSum
        ppmSum
        profitSum
        rebateSum
        bcId
        bcLast4
        bcStatus
        customerAccountId
        customerAccountName
        customerAppId
        customerAppStatus
        provisioningAccountId
        appId
        appName
        appLogo
        transactionId
        transactionTime
        bindCardCharge
        markup
        appbindFee
        profit
        rebate
        payments {
          paidId
          extSource
          extTransactionId
          paidAmount
          ppAmount
          psId
          psAccountId
          psCcBrand
          psCcLast4
          receivedAmount
        }
      }
    }
  }
  `;

  function fetch(startDate, endDate, appName, accountId, pAccountId, pOrder, first, offset) {
    const variables = {
        startDate: startDate, 
        endDate: endDate, 
        appName: appName, 
        accountId: accountId, 
        pAccountId: pAccountId, 
        pOrder: pOrder, 
        first: first, 
        offset: offset
    }
    
    return fetchQuery(
        abEnvironment.getEnvironment(),
        query,
        variables
    );
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { fetch };
